<template>
  <div class=''>
   
    <a v-show='certinfo.certType === 1' class="astyle" :href='ahref'>{{$t('lin_global.dachuzhengshu')}}</a>

    <el-button class='gSgLeftCtrl' style="margin-left:10px;"  type="primary" @click="uploadCer"  >{{$t('app_upload')}}{{$t('lin_global.zhengshu')}}</el-button>

    <el-row class='gPageBorder gTopMg gPdTB'>
      <el-col :span='12'>
        <el-form class='gShowLeftForm' label-position='left' label-width="30%">
          <el-form-item :label="$t('lin_global.certificateName') ">
            {{ certinfo.certificateName}}
          </el-form-item>
        </el-form>
      </el-col>

      <el-col :span='12'>
        <el-form class='gShowRightForm' label-position='left' label-width="30%">
          <el-form-item :label="$t('lin_global.createTime') ">
            {{ certinfo.createTime}}
          </el-form-item>
        </el-form>
      </el-col>

      <el-col :span='12'>
        <el-form class='gShowLeftForm' label-position='left' label-width="30%">
          <el-form-item :label="$t('lin_global.zdqds') ">
            {{ certinfo.distributorName}}
          </el-form-item>
        </el-form>
      </el-col>

      <el-col :span='12'>
        <el-form class='gShowRightForm' label-position='left' label-width="30%">
          <el-form-item :label="$t('lin_global.remark') ">
            {{ certinfo.certificateDesc}}
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    
    <!-- <el-row class="">
      <el-form :model="certinfo" label-position="right" class="gForm" id="certinfo" label-width="12.5%">
        <el-form-item style='' :label="$t('lin_global.certificateName') + ':'">
          {{ certinfo.certificateName}}
        </el-form-item>
        <el-form-item :label="$t('lin_global.createTime') + ':'">
          {{ certinfo.createTime}}
        </el-form-item>
        <el-form-item :label="$t('lin_global.zdqds') + ':'">
          {{ certinfo.distributorName}}
        </el-form-item>
        <el-form-item :label="$t('lin_global.remark') + ':'">
          {{ certinfo.certificateDesc}}
        </el-form-item>
        <el-form-item>
          
        </el-form-item>
      </el-form>
    </el-row> -->


  </div>
</template>
<script>
  import axios from 'axios'
  import { baseurl,urlAssets } from '../../api/url'
  export default{
    data(){
      return{
        ahref:'',
        certinfo:{},

      }
    },
    created () {
      this.getDetail();
    },
    methods:{
      uploadCer () {
        this.$setWObj('safeCerType', 0)
        this.$router.push({ path: '/mycer/upload' })
      },
      getDetail:function(){
        var mechanismId = localStorage.getItem('mechanismId');;
        var params = {distributorId:mechanismId};
        axios.post(`${baseurl}/cer/getByDistributorId.do`,params).then(res=>{
          if(res.data.status == 200){
            this.certinfo = res.data.data;
            //console.log(this.certinfo)
            //this.ahref = urlAssets.prefix + 'cer/privkey/' + res.data.data.certificateId + '.pem'
            this.ahref = urlAssets.prefix  + res.data.data.url;
          }
        })
      },
    }
  }
</script>
<style>
  .astyle{
    display: inline-block;
    line-height: 1;
    white-space: nowrap;
    cursor: pointer;
    background: #fff;
    border: 1px solid #c4c4c4;
    color: #1f2d3d;
    padding: 10px 15px;
    margin-top:4px;
    border-radius: 4px;
    color: #fff;
    background-color: #20a0ff;
    border-color: #20a0ff;
  }

</style>



// WEBPACK FOOTER //
// myCert.vue?5824f7de